import { StyleSheet, View } from 'react-native'

const defaultSize = 40;

export const Placeholder = ({ Left, style = {}, children } = {}) => {
	
	return (
		<View
			style={[
				styles.placeholderContainer,
				style,
			]}>
			
			<View
				style={ styles.placeholder }>
				
				{ Left }
				{ children }
			</View>
		</View>
	)
}

export const PlaceholderLine = ({ width = defaultSize } = {}) => {
	
	return (
		<View
			style={[
				styles.default,
				styles.line,
				{
					width: width,
					height: 4
				}
			]}
		/>
	)
}

export const PlaceholderMedia = ({ size = defaultSize, isRound = false } = {}) => {
	
	return (
		<View
			style={[
				styles.default,
				styles.media,
				{
					width: size,
					height: size,
					borderRadius: isRound ? size / 2 : 0
				}
			]}
		/>
	)
}

const styles = StyleSheet.create({
	default: {
		backgroundColor: '#E0E0E0'
	},
	placeholderContainer: {
	},
	placeholder: {
		display: 'flex',
		flexDirection: 'row',
	},
	line: {},
	media: {}
});
